"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styleGuideUrl = "http://elements-t.cloudapps.local.ergodirekt.de/version/9.9.4/";
exports.elementsVersion = "9.9.4";
//# sourceMappingURL=Provider.types.js.map